import React, { Component } from 'react'
import { graphql } from "gatsby"
import { Helmet } from 'react-helmet'


class LivNewsletter extends Component {
  constructor({ data }) {
    super()
    this.data = data;
  }
  

  componentDidMount() {
    const formCreate = (options) => {
      if (!window.hbspt) {
        setTimeout(() => {
          formCreate(options);
        }, 100);
      } else {
        window.hbspt.forms.create({ ...options });
      }
    };

    formCreate({
      region: "na1",
      portalId: "7001828",
      formId: "59dcd3f5-0fd5-47f4-a6b5-20d3d0366add",
      target: ".liv-signup",
    });
  }

  render() {

    return (
      <section>
        <Helmet>
          <script src="//js.hsforms.net/forms/v2.js"></script>
        </Helmet>
        <div className="w-1/2 m-auto mb-12">
          <div className="liv-signup" />
        </div>
      </section>
    )
  }
}

export default LivNewsletter;

export const livNewsletterQuery = graphql`
  fragment LivNewsletterComponent on DatoCmsLivNewsletter {
    internal {
      type
    }
  }
`